import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { makeObservable } from "abweb/utils/ConditionalMobx";
import { action, observable } from "mobx";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;

export let FormulaState = (_dec = observable.deep, _dec2 = observable.shallow, _class = class FormulaState {
  constructor(elements, operandValuesByElementId, generateId) {
    _initializerDefineProperty(this, "_elements", _descriptor, this);
    _initializerDefineProperty(this, "_operandValuesByElementId", _descriptor2, this);
    _defineProperty(this, "_generateId", void 0);
    this._elements = elements;
    this._operandValuesByElementId = operandValuesByElementId;
    this._generateId = generateId;
    makeObservable(this);
  }
  generateId() {
    return this._generateId();
  }
  get elements() {
    return this._elements;
  }
  set elements(value) {
    this._elements = value;
  }
  setOperandValueForElementId(elementId, value) {
    this._operandValuesByElementId[elementId] = value;
  }
  removeOperandValueForElementId(elementId) {
    delete this._operandValuesByElementId[elementId];
  }
  getOperandValueForElementId(elementId) {
    return this._operandValuesByElementId[elementId];
  }
  createStateSnapshot() {
    let newElements = this._elements.map(e => e);
    let newDataMap = {};
    for (let key of Object.keys(this._operandValuesByElementId)) {
      newDataMap[key] = this._operandValuesByElementId[key];
    }
    return new FormulaState(newElements, newDataMap, this._generateId);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_elements", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_operandValuesByElementId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "setOperandValueForElementId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOperandValueForElementId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeOperandValueForElementId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeOperandValueForElementId"), _class.prototype), _class);
//# sourceMappingURL=FormulaState.js.map
